import TopBarProgress from 'react-topbar-progress-indicator'

export default function LoadingIndicator() {
  TopBarProgress.config({
    barColors: {
      '0': '#2ad590',
    },
    barThickness: 3,
    shadowBlur: 5,
  })

  return (
    <>
      <TopBarProgress />
    </>
  )
}
